<div class="container-fluid">
    <ng-http-loader></ng-http-loader>
    <router-outlet></router-outlet>
</div>